import React from "react"
import { Link, graphql } from "gatsby"
import styled from "@emotion/styled"
import Banner from "../components/banner"
import { Header1 } from "../components/headings"
import Layout from "../components/layout"
import Events from "../components/Index/events"
import SocialMedia from "../components/Index/socialMedia"
import Rankings from "../components/Index/rankings"
import Records from "../components/Index/records"
import Subscribe from "../components/Index/subscribe"
import News from "../components/Index/news"
import Carousel from "../components/Index/carousel"
import SEO from "../components/seo";
import Modal from "../components/modal"
import { PrimaryButton } from "../components/buttons"
import backgroundImage from "../images/records-background.png";
import sponsorBanner from "../images/draftking-banner.png";
import hatTip from "../images/hat-tip.png";

const BackgroundContainer = styled.div`
  background-image: ${props => props.background};
  background-size: cover;
  background-position-y: -500px;
  background-repeat-y: no-repeat;
`

const HeroTextWrap = styled.div`
  position: relative;
  display: inline-block;
  text-align: right;
`

const HeroHat = styled.img`
  position: absolute;
  /* anchor to the top-right corner of the text block (the end of "...of") */
  top: 0;
  right: 0;
  width: 210px;
  /* sit just off the top-right of "of" */
  transform: translate(39%, -57%) rotate(-11deg);
  pointer-events: none;
  filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.45));
  @media (max-width: 768px) {
    width: 130px;
    transform: translate(22%, -52%) rotate(-11deg);
  }
`

const IndexPage = ({ data, pageContext }) => {
  return (
    <Layout>      
      <SEO title="Home" keywords={[`eating`, `contests`, `official`]} />
 
<Banner img={data.placeholderImage.childImageSharp.fluid}>
        <HeroTextWrap>
          <HeroHat src={hatTip} alt="" aria-hidden="true" />
          <Header1>
            <div
              style={{ fontSize: "2rem", lineHeight: "3rem", fontWeight: 300 }}
            >
              The Professional League of
            </div>
            <div>Eating Contests</div>

          </Header1>
        </HeroTextWrap>
        <Link to="/contests">
          <PrimaryButton>View Events</PrimaryButton>
        </Link>
      </Banner>
      <SocialMedia initialYoutubeVideos={pageContext?.youtubeVideos || []} />
      <Events documents={data.allStrapiContests.edges.filter(edge => edge.node.hide !== "true" && edge.node.hide !== "1")} />
      <Rankings eaters={data.allStrapiProfiles.edges} />
      <BackgroundContainer
        background={`url(${backgroundImage}), linear-gradient(#11202a, #0a1721)`}
      >
        <Records records={data.allStrapiRecords.edges} />
        <News
          news={data.allStrapiArticles.edges}
          img={data.newsImage.childImageSharp.fluid}
        />
      </BackgroundContainer>
      <Carousel logos={data.allStrapiLogos.edges} />
      <Subscribe />
    </Layout>
  )
}
export default IndexPage

export const pageQuery = graphql`
  query IndexQuery {
    allStrapiArticles(limit: 3, sort: { fields: [createdAt], order: [DESC] }) {
      edges {
        node {
          sn
          id
          title
          createdAt(formatString: "MM/DD/YYYY")
          content
        }
      }
    }
    allStrapiRecords(limit: 11, sort: { fields: [food] }) {
      edges {
        node {
          food
          description
          time
          profile {
            nameL
            nameF
          }
        }
      }
    }
    allStrapiProfiles(
      filter: { rank: { lte: 50 } }
      limit: 3
      sort: { fields: [rank] }
    ) {
      edges {
        node {
          nameF
          nameL
          sn
          rank
          image {
            publicURL
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
    allStrapiContests(
      limit: 50
      sort: { fields: [date], order: [DESC] }
    ) {
      edges {
        node {
          id
          name
          prize
          discipline
          sn
          date
          hide
          logo {
            image {
              url
              publicURL
            }
          }
        }
      }
    }
    allStrapiLogos(filter: { showInCarousel: { eq: true } }) {
      edges {
        node {
          link
          image {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
    placeholderImage: file(relativePath: { eq: "index-banner.png" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    newsImage: file(relativePath: { eq: "george.png" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
